import { trackAnalyticsEvent } from '@autone/analytics';
import { useAutoneTranslation } from '@autone/translations';
import { useState } from 'react';

import { Button } from '../../../atoms/Button';
import { ChatIcon } from '../../../icons';
import { SIDEBAR_MENU_BUTTON_STYLE_OVERRIDES } from '../constants/sidebarMenuButtonStyleOverrides';

export const SidebarChatButton = () => {
  const { common } = useAutoneTranslation();
  const [isOpen, setIsOpen] = useState(false);

  const handleChatClick = () => {
    trackAnalyticsEvent({
      category: 'sidebar',
      action: 'chat_button_clicked',
    });
    // @ts-ignore TODO fix this type
    window.Intercom(isOpen ? 'hide' : 'show');
    setIsOpen(!isOpen);
  };

  return (
    <Button
      onClick={handleChatClick}
      className={SIDEBAR_MENU_BUTTON_STYLE_OVERRIDES}
      variant="ghost"
      id="sidebar-chat-button"
      aria-label={common('chat-with-us')}
    >
      <ChatIcon />
      <span className="text-sm font-normal group-data-[state=collapsed]:hidden">
        {common('chat-with-us')}
      </span>
    </Button>
  );
};
